import "../css/contact.css";
import CV from "../files/CV-Melvin-Ruiz-Batista.pdf";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const [t] = useTranslation("global");

  return (
    <div className="divContainerContact" id="contacts" data-aos="fade-up">
      <h1>{t("Contacts.titleContact")}</h1>

      <div className="descriptionContact col-md-3" data-aos="flip-right">
        <p>{t("Contacts.descriptionContact")}</p>
      </div>

      <div className="containerIconsContact">
        <a href="mailto:melvinruizbatista27.m@gmail.com">
          {" "}
          <i className=" icon fa fa-envelope" data-aos="fade-left"></i>
        </a>
        <a
          href="https://www.instagram.com/melvinj_7/?hl=es-la"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="icon fa fa-instagram" data-aos="fade-right"></i>
        </a>
        <a
          href="https://github.com/MelvinRB27/MelvinRB27"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="icon fa fa-github" data-aos="fade-left"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/melvin-ruiz-batista-92889b153/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="icon fa fa-linkedin" data-aos="fade-right"></i>
        </a>
      </div>

      <a
        className="btnDownload"
        href={CV}
        download="CV-MELVIN-RUIZ-BATISTA.pdf"
      >
        <button className="btn btn-dark" data-aos="fade-down-left">
          <i className="fa fa-download"></i> {t("Contacts.btn_cv")}
        </button>
      </a>
    </div>
  );
};
export default Contact;
